import React, { useState } from "react";
import { toast } from "react-toastify";
import api from "../../api";
import { FaBell, FaFileAlt, FaCalendarCheck, FaEnvelopeOpenText } from "react-icons/fa";

const bool = (v) => v === true || v === "true" || v === "1" || v === 1;

export default function NotificationsTab({ raw, onSaved }) {
  const [form, setForm] = useState({
    quote_followup_enabled: bool(raw.quote_followup_enabled),
    quote_followup_hours: parseInt(raw.quote_followup_hours) || 72,
    appt_reminder_enabled: bool(raw.appt_reminder_enabled),
    digest_enabled: bool(raw.digest_enabled),
  });
  const [saving, setSaving] = useState(false);

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/settings", {
        quote_followup_enabled: String(form.quote_followup_enabled),
        quote_followup_hours: String(Math.max(1, parseInt(form.quote_followup_hours) || 72)),
        appt_reminder_enabled: String(form.appt_reminder_enabled),
        digest_enabled: String(form.digest_enabled),
      });
      toast.success("Planification enregistrée");
      onSaved?.();
    } catch (e) {
      toast.error(e?.response?.data?.error || "Échec de l'enregistrement");
    } finally {
      setSaving(false);
    }
  };

  const Row = ({ icon, title, desc, children }) => (
    <div className="flex items-start justify-between gap-4 rounded-xl border border-base-200 p-4">
      <div className="flex items-start gap-3 min-w-0">
        <div className="w-9 h-9 rounded-lg bg-primary/10 text-primary flex items-center justify-center shrink-0">{icon}</div>
        <div className="min-w-0">
          <div className="font-semibold text-base-content">{title}</div>
          <div className="text-xs text-base-content/50 mt-0.5">{desc}</div>
        </div>
      </div>
      <div className="shrink-0">{children}</div>
    </div>
  );

  return (
    <div className="max-w-2xl space-y-4">
      <p className="text-sm text-base-content/50 flex items-center gap-2">
        <FaBell /> Envois automatiques propres à votre organisation.
      </p>

      <Row
        icon={<FaFileAlt />}
        title="Relance des devis en attente"
        desc="Crée une notification de relance pour les devis restés sans réponse."
      >
        <label className="flex items-center gap-2 cursor-pointer">
          <input type="checkbox" className="toggle toggle-primary toggle-sm" checked={form.quote_followup_enabled} onChange={(e) => set("quote_followup_enabled", e.target.checked)} />
        </label>
      </Row>

      {form.quote_followup_enabled && (
        <div className="flex items-center justify-between gap-4 rounded-xl border border-base-200 p-4 ml-6">
          <span className="text-sm text-base-content/60">Délai avant relance</span>
          <div className="flex items-center gap-2">
            <input
              type="number" min="1"
              className="input input-bordered input-sm w-24"
              value={form.quote_followup_hours}
              onChange={(e) => set("quote_followup_hours", e.target.value)}
            />
            <span className="text-sm text-base-content/50">heures</span>
          </div>
        </div>
      )}

      <Row
        icon={<FaCalendarCheck />}
        title="Rappel client la veille du RDV"
        desc="Email (et SMS si activé) au client la veille de son rendez-vous."
      >
        <input type="checkbox" className="toggle toggle-primary toggle-sm" checked={form.appt_reminder_enabled} onChange={(e) => set("appt_reminder_enabled", e.target.checked)} />
      </Row>

      <Row
        icon={<FaEnvelopeOpenText />}
        title="Digest quotidien des RDV (interne)"
        desc="Récapitulatif des rendez-vous envoyé à l'équipe."
      >
        <input type="checkbox" className="toggle toggle-primary toggle-sm" checked={form.digest_enabled} onChange={(e) => set("digest_enabled", e.target.checked)} />
      </Row>

      <div className="flex justify-end">
        <button onClick={save} disabled={saving} className="btn btn-primary btn-sm">{saving ? "…" : "Enregistrer"}</button>
      </div>
    </div>
  );
}
